export enum ItemOrQuantityIssueTypeDomestic {
    SHIPMENT_OVERAGE = 'Shipment Overage',
    SHIPMENT_SHORTAGE = 'Shipment Shortage',
    MISSING_ITEM = 'Missing Item',
    WRONG_SMN_SHIPPED = 'Wrong SMN Shipped',
    WRONG_BATCH_SHIPPED = 'Wrong Batch Shipped',
    WRONG_SERIAL_SHIPPED = 'Wrong Serial Shipped',
    SPLIT_SHIPMENT = 'Split Shipment',
    RECEIVED_UNORDERED_ITEM = 'Received Unordered Item'
}
